// @ts-nocheck
import React from "react";

import { Box, Typography, withStyles, createStyles } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import { surveyStyles,aboutUsStyle } from "./surveyStyles";
import QuestionCard from "./layout/QuestionCard.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";
import OptionRow from "./layout/OptionRow.web";
import {
  MagicLinkTextField,
  MagicLinkSelectField,
} from "./layout/FormFields.web";
import { magicLinkFormOverrides } from "./layout/formStyleOverrides";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const ACCOUNTING_SYSTEMS = [
  "None",
  "Quickbooks Online",
  "Quickbooks Desktop",
  "Xero",
  "Zoho",
  "Freshbooks",
  "Other",
];
const ENTITY_STRUCTURES = [
  "S-Corp",
  "C-Corp",
  "Sole Proprietorship",
  "LLC",
  "Partnership",
];
const BUSINESS_PARTNER_OPTIONS = [
  { value: 0, label: "None" },
  ...[1, 2, 3, 4, 5].map((count) => ({ value: count, label: String(count) })),
];
const toOptions = (items) => items.map((item) => ({ value: item, label: item }));

const BusinessSchema = Yup.object().shape({
  industryType: Yup.string()
    .required("This field is required")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed for this field")
    .nullable(),
  currentAccountingSystem: Yup.string().required("This field is required"),
  annualRevenue: Yup.string().required("This field is required"),
  otherBusinessPartner: Yup.string().required("This field is required"),
  currentEntityStructure: Yup.string().required("This field is required"),
  noOfEmployee: Yup.string()
    .required("This field is required")
    .matches(/^\d*$/, "Employee should contain only positive numbers"),
  currentPayRollSystem: Yup.string(),
  isManagePayroll: Yup.boolean(),
});
export const BusinessCompnent = (props) => {
  const { classes, titleMessage, gotoBackStep, gotoNextStep } = props;
  const checkIfNumber = (e, setFieldValue) => {
    const regex = /\d+(\.\d\d?)?/;
    if (
      e.target.value === "" ||
      (regex.test(e.target.value) && e.target.value.length < 12)
    ) {
      let t = e.target.value;
      t =
        t.indexOf(".") >= 0
          ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
          : t;
      let nf = new Intl.NumberFormat("en-US");
      setFieldValue(
        "annualRevenue",
        nf.format(t.replace(/,/g, "")) === "0"
          ? ""
          : nf.format(t.replace(/,/g, ""))
      );
    }
  };
  const getHelpText = (errors, touched, key) => {
    return touched[key] && errors[key] ? errors[key] : "";
  };
  const getError = (errors, touched, key) => {
    return touched[key] && errors[key];
  };

  return (
    <Fade in={true} timeout={3000}>
      <Formik
        initialValues={{
          industryType: props.industryType,
          currentAccountingSystem: props.currentAccountingSystem,
          annualRevenue: props.annualRevenue,
          otherBusinessPartner: props.otherBusinessPartner,
          currentEntityStructure: props.currentEntityStructure,
          noOfEmployee: props.noOfEmployee,
          currentPayRollSystem: props.currentPayRollSystem,
          isManagePayroll: props.isManagePayroll,
        }}
        validationSchema={BusinessSchema}
        validateOnMount
        // enableReinitialize
        onSubmit={() => {
          gotoNextStep();
        }}
      >
        {(formikProps) => {
          const {
            values,
            handleBlur,
            handleChange,
            setFieldValue,
            isValid,
            errors,
            touched,
          } = formikProps;
          const handleInputChange = (event) => {
            props.setValueByDynamicName(event.target.name, event.target.value);
            handleChange(event);
          };
          const handleNumberChange = (event) => {
            props.setValueByDynamicName("annualRevenue", event.target.value);
            checkIfNumber(event, setFieldValue);
          };
          const handleKeyPress = (event) => {
            if (
              (event.charCode != 8 && event.charCode == 0) ||
              (event.charCode >= 48 && event.charCode <= 57)
            ) {
              console.log(event);
            } else {
              event.preventDefault();
            }
          };
          const hamdleEmplyeeChg = (event) => {
            props.setValueByDynamicName("noOfEmployee", event.target.value);
            handleChange(event);
            if (event.target.value == 0) {
              props.setValueByDynamicName("currentPayRollSystem", "");
              setFieldValue("currentPayRollSystem", "");
            }
          };
          const togglePayroll = () => {
            const isManagePayroll = !values.isManagePayroll;
            props.setValueByDynamicName("isManagePayroll", isManagePayroll);
            setFieldValue("isManagePayroll", isManagePayroll);
          };
          const goBack = (m) => {
            setFieldValue("industryType", "");
            setFieldValue("currentAccountingSystem", "None");
            setFieldValue("annualRevenue", "");
            setFieldValue("otherBusinessPartner", 0);
            setFieldValue("currentEntityStructure", "S-Corp");
            setFieldValue("noOfEmployee", "");
            setFieldValue("currentPayRollSystem", "");
            setFieldValue("isManagePayroll", false);
            props.setValueByDynamicName("industryType", "");
            props.setValueByDynamicName(
              "currentAccountingSystem",
              "None"
            );
            props.setValueByDynamicName("annualRevenue", "");
            props.setValueByDynamicName(
              "otherBusinessPartner",
              0
            );
            props.setValueByDynamicName(
              "currentEntityStructure",
              "S-Corp"
            );
            props.setValueByDynamicName("noOfEmployee", "");
            props.setValueByDynamicName(
              "currentPayRollSystem",
              ""
            );
            props.setValueByDynamicName("isManagePayroll", false);

            gotoBackStep();
          }
           return (
            <Form autoComplete="off" noValidate>
              <QuestionCard
                title={titleMessage}
                hint="In order to show you the right feature options, we need a few more details about your business"
              >
                <Box className={classes.businessFields}>
                  <MagicLinkTextField
                    label="Industry"
                    name="industryType"
                    id="industryType"
                    placeholder="Add your industry here"
                    value={values.industryType}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    error={getHelpText(errors, touched, "industryType")}
                  />
                  <MagicLinkSelectField
                    label="Current accounting system"
                    name="currentAccountingSystem"
                    id="currentAccountingSystem"
                    value={values.currentAccountingSystem}
                    options={toOptions(ACCOUNTING_SYSTEMS)}
                    onChange={handleInputChange}
                    error={getHelpText(errors, touched, "currentAccountingSystem")}
                  />
                  <MagicLinkTextField
                    label="Annual Revenue"
                    name="annualRevenue"
                    id="annualRevenue"
                    prefix="$"
                    placeholder="Total Annual Revenue"
                    value={values.annualRevenue}
                    onKeyPress={handleKeyPress}
                    onChange={handleNumberChange}
                    onBlur={handleBlur}
                    error={getHelpText(errors, touched, "annualRevenue")}
                  />
                  <MagicLinkSelectField
                    label="Other Business Partner"
                    name="otherBusinessPartner"
                    id="otherBusinessPartner"
                    value={values.otherBusinessPartner}
                    options={BUSINESS_PARTNER_OPTIONS}
                    onChange={handleInputChange}
                    error={getHelpText(errors, touched, "otherBusinessPartner")}
                  />
                  <MagicLinkSelectField
                    label="Current entity structure"
                    name="currentEntityStructure"
                    id="currentEntityStructure"
                    value={values.currentEntityStructure}
                    options={toOptions(ENTITY_STRUCTURES)}
                    onChange={handleInputChange}
                    error={getHelpText(errors, touched, "currentEntityStructure")}
                  />
                </Box>
                <Box className={classes.payrollFields}>
                  <MagicLinkTextField
                    label="Number of Employees"
                    name="noOfEmployee"
                    id="noOfEmployee"
                    type="number"
                    placeholder="Add"
                    value={values.noOfEmployee}
                    onChange={hamdleEmplyeeChg}
                    onBlur={handleBlur}
                    error={getHelpText(errors, touched, "noOfEmployee")}
                  />
                  <MagicLinkTextField
                    label="Current Payroll System"
                    name="currentPayRollSystem"
                    id="currentPayRollSystem"
                    placeholder="Add"
                    disabled={props.noOfEmployee <= 0}
                    value={values.currentPayRollSystem}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    error={getHelpText(errors, touched, "currentPayRollSystem")}
                  />
                </Box>
                <Box className={classes.payrollHelp}>
                  <Typography className={classes.statusHeading}>
                    Do you want help managing your payroll?
                  </Typography>
                  <OptionRow
                    multiple
                    inputId="isManagePayroll"
                    label="Yes, I want help managing my payroll moving forward"
                    selected={!!values.isManagePayroll}
                    disabled={props.noOfEmployee < 1}
                    onSelect={togglePayroll}
                  />
                </Box>
              </QuestionCard>
              <FirmQuestions
                screen="business_details"
                taxPayerType={props.taxPayerType}
                questions={props.firmQuestions}
                answers={props.firmAnswers}
                onChange={props.setFirmAnswer}
              />
              <StepFooter
                onBack={goBack}
                backId="backButton"
                nextType="submit"
                nextId="statucNextButton"
                nextDisabled={!isValid}
              />
            </Form>
          );
        }}
      </Formik>
    </Fade>
  );
};
export default withStyles((theme) =>
  createStyles({
    ...surveyStyles(theme),
    ...aboutUsStyle(theme),
    ...magicLinkFormOverrides(theme),
    businessFields: {
      display: "grid",
      gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
      gap: 32,
      padding: "20px 0",
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: 16,
      },
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
      },
    },
    payrollFields: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 32,
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
        gap: 16,
      },
    },
    payrollHelp: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      padding: "8px 0 0",
    },
  })
)(BusinessCompnent);
